<template>
    <ModalFormCard class="modal-default" :action="action" v-bind="{ errors, saving }">
        <template #title>Create event</template>

        <template #default="{ saving, errors }">
            <p>Would you like to create a new task or an event?</p>

            <div class="modal-buttons">
                <button
                    class="button-black h-12 default"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'Task',
                                options: {
                                    task: 0,
                                    starts_at: editingModel.date,
                                },
                            })
                        }
                    "
                >
                    New task
                </button>
                <button
                    class="button-black h-12 default"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'Task',
                                options: {
                                    task: 1,
                                    starts_at: editingModel.date,
                                },
                            })
                        }
                    "
                >
                    New event
                </button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],
}
</script>
